<!--
 * @Author: wangyinhu wangyinhude@163.com
 * @Date: 2025-04-08 10:57:17
 * @LastEditors: wangyinhu wangyinhude@163.com
 * @LastEditTime: 2026-03-11 15:24:22
 * @FilePath: \hxt-saas-pc\src\App.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div id="app">
    <!-- 只有在数据加载完成后才渲染 router-view -->
    <router-view v-if="dataLoaded"></router-view>
  </div>
</template>

<script>
import { userCompanyInfo, checkDeptExpire } from '@/api/index.js';

export default {
  name: 'app',
  provide() {
    return {
      reload: this.reload,
      token: "",
    }
  },
  data() {
    return {
      isRouterAlive: true,
      dataLoaded: false // 控制 router-view 是否渲染
    }
  },
  created() {
    var host = window.location.host;

    if (this.isWorkWechat()) {
      localStorage.setItem('TopDeptId', '35');
      console.log(111111111, '企业微信登录')
      if (host !== 'zswpx.saas-test.taxchina.com' && process.env.NODE_ENV === 'development') {
        this.$message.error('当前域名无权访问!');
        setTimeout(() => {
          location.replace('http://zswpx.saas-test.taxchina.com/');
        }, 1000);
      } else if (process.env.NODE_ENV === 'production') {
        if (host !== 'zswpx.saas.taxchina.com') {
          this.$message.error('当前域名无权访问!');
          setTimeout(() => {
            location.replace('http://zswpx.saas.taxchina.com/');
          }, 1000);
        }
      }
    }

    this.getTodept();
  },
  methods: {
    isWorkWechat() {
      var ua = window.navigator.userAgent.toLowerCase();
      return (ua.match(/micromessenger/i) == 'micromessenger') && (ua.match(/wxwork/i) == 'wxwork');
    },
    getTodept() {
      var token = window.localStorage.getItem("token");
      var dept = window.localStorage.getItem("dept");

      if (token) {
        userCompanyInfo({}, { Authorization: token }).then(res => {
          if (res.code == 200) {
            localStorage.setItem('TopDeptId', res.data.topDeptId);
            localStorage.setItem('dept', res.data.deptId);

            // 等待 checkDeptExpire 完成后再设置 dataLoaded 为 true
            checkDeptExpire({}, {
              Authorization: token,
              TopDeptId: res.data.topDeptId
            }).then(res => {
              localStorage.setItem('gqxx', JSON.stringify(res.data));
              // var data1 = {
              //   "expire": 1,//0=未过期，1=已过期，2=快要过期
              //   "days": 20//时对应的天数
              // }
              // localStorage.setItem('gqxx', JSON.stringify(data1));

              // 数据加载完成，允许渲染 router-view
              this.dataLoaded = true;


              // debugger;
              this.dataLoaded = true;

            }).catch(() => {
              // 即使失败也允许渲染页面
              this.dataLoaded = true;
            });
          } else {
            this.dataLoaded = true;
          }
        }).catch(() => {
          this.dataLoaded = true;
        });
      } else {
        this.dataLoaded = true;
      }
    },
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  }
}
</script>
<style lang="less">
html,
body {
  margin: 0;
  padding: 0;
  background: #F5F5F4;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.image {
  width: 100%;
  height: 100%;
}

@keyframes animi {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

/* 定义滚动条的宽度和高度 */
::-webkit-scrollbar {
  width: 8px;
  /* 滚动条宽度 */
  height: 8px;
  /* 滚动条高度 */
}

/* 定义滚动条轨道的样式 */
::-webkit-scrollbar-track {
  background: #f1f1f1;
  /* 滚动条轨道背景颜色 */
}

/* 定义滚动条滑块的样式 */
::-webkit-scrollbar-thumb {
  background: #888;
  /* 滑块颜色 */
}

/* 鼠标悬停时滚动条滑块的样式 */
::-webkit-scrollbar-thumb:hover {
  background: #555;
  /* 悬停时滑块颜色 */
}
</style>
